import { apiRequest } from './axiosConfig';
import { AIAgent } from '../../types';

// APIレスポンス型定義
interface FavoriteAgentsResponse {
  success?: boolean;
  data?: AIAgent[];
  agents?: AIAgent[];
  message?: string;
}

/**
 * お気に入りエージェントのAPIサービス
 */
const favoriteAgentService = {
  /**
   * お気に入りエージェント一覧を取得
   */
  getFavorites: async () => {
    try {
      const config = { timeout: 30000 }; // タイムアウトを30秒に設定
      
      // aiAgentService と同じタイプのリクエストを使用（apiRequestを使用）
      const response = await apiRequest.get<FavoriteAgentsResponse>('/ai-agents/favorites', config);
      
      // レスポンスの形式を確認して適切に処理
      // バックエンドからのレスポンスは { success: true, data: [...エージェントの配列...] } 形式
      
      if (response.data && Array.isArray(response.data)) {
        return { data: response.data };
      } else if (response.agents && Array.isArray(response.agents)) {
        return { data: response.agents };
      } else if (Array.isArray(response)) {
        return { data: response };
      } else {
        console.warn('お気に入りエージェントデータが適切な形式ではありません', response);
        return { data: [] };
      }
    } catch (error) {
      console.error('お気に入り取得エラー:', error);
      // エラー時は空の配列を返す
      return { data: [] };
    }
  },

  /**
   * エージェントのお気に入り状態を切り替え
   * @param id エージェントID
   */
  toggleFavorite: async (id: number) => {
    try {
      const config = { timeout: 15000 }; // タイムアウトを15秒に設定
      const response = await apiRequest.post<{success: boolean, is_favorited: boolean}>(`/ai-agents/${id}/favorite`, {}, config);
      return { data: response };
    } catch (error) {
      console.error(`お気に入りトグルエラー (id: ${id}):`, error);
      // エラーをモーダルで表示できるよう上位に伝播させる
      throw error;
    }
  }
};

export default favoriteAgentService;
